import Client from 'config/axios';
import posthog from 'posthog-js';

export const activeBonusByGroup = async (token: string, groupId: any) => {
  const { data } = await Client.post(
    `activate-allow-bonus-by-group/${groupId}`,
    null,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
  posthog.capture('ActiveBonusByGroup', {
    ActiveBonusByGroup: data
  });
  return {
    data
  };
};
